export const BAR_COMPONENT_ID = 'dvm:unified-bar';
export const BAR_PRESETS = [
  {id:'vertical',label:'Vertical / column'}, {id:'horizontal',label:'Horizontal'},
  {id:'grouped',label:'Grouped / clustered'}, {id:'stacked',label:'Stacked'},
  {id:'percent',label:'100% stacked'}, {id:'grouped-stacked',label:'Grouped stacked'},
  {id:'diverging',label:'Positive / negative'}, {id:'diverging-stacked',label:'Diverging stacked'},
  {id:'overlap',label:'Overlapping'}, {id:'range',label:'Floating / range'},
  {id:'waterfall',label:'Waterfall'}, {id:'race',label:'Bar race'},
  {id:'polar',label:'Polar / radial'}, {id:'polar-stacked',label:'Stacked polar'},
] as const;
export type BarPreset = typeof BAR_PRESETS[number]['id'];
export interface BarAppearance {
  colors: string[]; background: string; textColor: string; fontFamily: string; fontSize: number;
  showLegend: boolean; legendPosition:'top'|'bottom'|'right'; showLabels:boolean; showTooltip:boolean;
  showGrid:boolean; showXAxis:boolean; showYAxis:boolean; xTitle:string; yTitle:string;
  labelRotation:number; decimals:number; barWidth:number; gap:number; radius:number;
  animation:boolean; zoom:boolean; sort:'none'|'asc'|'desc'; topN:number;
  min?:number|null; max?:number|null; positiveColor:string; negativeColor:string;
}
export interface BarConfig extends Record<string,unknown> {
  title:string; variant:BarPreset; orientation:'vertical'|'horizontal'; dataMode:'sample'|'api'|'inline';
  apiUrl:string; method:'get'|'post'; dataKey:string; headers:Record<string,string>;
  rawPayload:Record<string,unknown>|unknown[]; categoryKey:string; valueKey:string;
  seriesKey:string; stackKey:string; startKey:string; endKey:string; frameKey:string; totalKey:string;
  raceInterval:number; appearance:BarAppearance;
}
export function defaultBarConfig():BarConfig {
  return {title:'Bar chart',variant:'vertical',orientation:'vertical',dataMode:'sample',apiUrl:'',method:'get',dataKey:'rows',headers:{},rawPayload:{},
    categoryKey:'category',valueKey:'value',seriesKey:'series',stackKey:'stack',startKey:'start',endKey:'end',frameKey:'frame',totalKey:'total',raceInterval:1500,
    appearance:{colors:['#2878b5','#38a6a5','#8b78c6','#e7aa46','#dc7183','#64748b'],background:'#ffffff',textColor:'#334155',fontFamily:'Arial, sans-serif',fontSize:12,
      showLegend:true,legendPosition:'bottom',showLabels:false,showTooltip:true,showGrid:true,showXAxis:true,showYAxis:true,xTitle:'',yTitle:'',labelRotation:0,decimals:0,
      barWidth:65,gap:25,radius:2,animation:true,zoom:false,sort:'none',topN:0,min:null,max:null,positiveColor:'#38a6a5',negativeColor:'#db6574'}};
}
export function normalizeBarConfig(value:Partial<BarConfig>):BarConfig {
  const defaults=defaultBarConfig();
  return {...defaults,...value,variant:BAR_PRESETS.some(p=>p.id===value.variant)?value.variant!:defaults.variant,appearance:{...defaults.appearance,...value.appearance}};
}
export function selectBarPreset(config:BarConfig,variant:BarPreset):BarConfig {return {...structuredClone(config),variant};}
export function barSampleUrl(variant:BarPreset):string {return `assets/design-builder/bar-charts/${variant}.json`;}
export function barRequest(config:BarConfig):{url:string;method:'get'|'post';data:BarConfig} {
  return config.dataMode==='api' ? {url:config.apiUrl.trim(),method:config.method,data:config} : {url:barSampleUrl(config.variant),method:'get',data:config};
}
